module.exports = __webpack_public_path__ + "img/Avatar-20.33326a6c.svg";